import { render, staticRenderFns } from "./changelog-merge.vue?vue&type=template&id=75770aa8"
import script from "./changelog-merge.vue?vue&type=script&lang=js"
export * from "./changelog-merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports